import { FormControl } from '@angular/forms'


export enum WARRANTY_TYPE {
  EQUIPMENTS = 'equipments',
  MAINTENANCES = 'maintenances',
}


export const WARRANTIES_TYPES: { value: WARRANTY_TYPE; label: string }[] = [
  { value: WARRANTY_TYPE.MAINTENANCES, label: 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.FILTERS.MAINTENANCES' },
  { value: WARRANTY_TYPE.EQUIPMENTS, label: 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.FILTERS.EQUIPMENTS' },
]

export interface WarrantyForm {
  id: FormControl<string | null>
  name: FormControl<string | null>
  description: FormControl<string | null>
  value: FormControl<number | null>
  coverageDurationDays: FormControl<number | null>
  extendedCoverageDurationDays: FormControl<number | null>
  extendedValue: FormControl<number | null>
  coverageStartedAt: FormControl<string | null>
  coverageEndedAt: FormControl<string | null>
  extendedCoverageEndedAt: FormControl<string | null>
  hasCoverageExtend: FormControl<boolean | null>
  warrantyTemplateId: FormControl<string | null>
  maintenancesTypes: FormControl<string[] | null>
  companyId: FormControl<string | null>
}

